import { useEffect, useRef, useCallback } from 'react';

/**
 * Hook phục hồi vị trí cuộn trang
 * @param {string} key - Tên định danh duy nhất cho màn hình (vd: 'customer_list', 'report_revenue')
 * @param {boolean} isReady - Cờ báo hiệu dữ liệu đã load xong để bắt đầu cuộn
 * @param {boolean} condition - Điều kiện phụ (vd: chỉ cuộn khi View đang đóng)
 */
export default function useScrollRestoration({ key, isReady, condition = true }) {
  const scrollRef = useRef(null);
  const hasRestoredScroll = useRef(false);

  // 1. Tự động phục hồi vị trí cuộn
  useEffect(() => {
    if (isReady && condition && scrollRef.current && !hasRestoredScroll.current) {
      const savedPosition = sessionStorage.getItem(`scroll_pos_${key}`);
      
      if (savedPosition) {
        // Dùng setTimeout để đảm bảo DOM đã render xong 100%
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = Number(savedPosition);
          }
        }, 0);
      }
      // Bật cờ để không cuộn đi cuộn lại nhiều lần
      hasRestoredScroll.current = true;
    }
  }, [isReady, condition, key]);

  // 2. Hàm lưu vị trí cuộn (expose ra ngoài để dùng trong onScroll)
  const saveScroll = useCallback((event) => {
    if (event?.currentTarget) {
      sessionStorage.setItem(`scroll_pos_${key}`, event.currentTarget.scrollTop);
    }
  }, [key]);

  // 3. Hàm reset (Dùng khi bạn muốn ép xóa vị trí cuộn, vd: khi bấm Tìm kiếm mới)
  const resetScroll = useCallback(() => {
    hasRestoredScroll.current = false;
    sessionStorage.removeItem(`scroll_pos_${key}`);
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, [key]);

  return { scrollRef, saveScroll, resetScroll, hasRestoredScroll };
}